import React, {useEffect, useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import ModalForm from "../../components/form/ModalForm";
import SatFormConfig from "../format/config/SatFormConfig";
import AddButton from "../../components/button/AddButton";
import {useHistory} from "react-router-dom";
import columns from "./FontTableConfig";
import {FontTableActions} from "./FontTableActions";
import {Actions} from "../../../client/Actions";
import {hasFontManagementFullAccess, hasFontManagementView} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

const FontTablePage = (props) => {

    const [loader, setLoader] = useState(false);
    const [satDetails, setSatDetails] = useState();
    const history = useHistory();
    const { t } = useTranslation();
    const models = useModels();

    const createInventory = (machineId, onCreated) => {
        setLoader(true)
        Actions.post("fontInventory/create", {machineId: machineId}, onCreated)
    }

    const actionColumn = {
        field: "actions",
        label: t("common.actions"),
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history, reload, setReload, setLoader) {
            return <FontTableActions
                history={history}
                row={row}
                reload={reload}
                setReload={setReload}
                setLoader={setLoader}
                createInventory={createInventory}
            />
        }
    }

    function checkAccess() {
        if (!hasFontManagementView()) {
            history.push("/")
        }
    }

    useEffect(checkAccess, [])

    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("menu.font_management")}
                             parent={
                                 <LinkIconButton
                                     model={models.font}
                                     props={props}
                                 />
                             }
                             subtitle={<>
                                 {hasFontManagementFullAccess() &&
                                     <AddButton
                                         onClick={() => history.push("/font")}
                                     />
                                 }
                             </>}
            >


                <CardTable
                    title={t("common.machine_list")}
                    source={"font/machines"}
                    columns={columns(t).concat([actionColumn])}
                    width={12}
                    setLoader={setLoader}
                    striped={false}
                    shadow={true}
                />
            </CustomContainer>
            <ModalForm
                open={!!satDetails}
                setOpen={setSatDetails}
                shadow={false}
                fields={SatFormConfig}
                setLoader={props.setLoader}
                initialData={satDetails}
                readOnly={true}
                title={t("common.sat")}
                size={"md"}
            />
        </>
    );
};

export default FontTablePage;
